import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const HighlyEngagedLeadIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "HighlyEngagedLead",
    children: /*#__PURE__*/_jsx("path", {
      d: "M24.01 11.77c-1.02-.3.16.88.06 2.78-.08 1.46-1.73 2.92-2.52 2.57-.92-.4.85-5.26-1.65-9.44-2.08-3.46-8.2-6.78-7.78-5.35C14.19 9.22 6.94 13 5.33 17.09c-1.92 4.9.15 11.11 6.5 12.89.19.05.32-.19.18-.32-1.26-1.26-2.56-2.78-2.76-4.61-.27-2.55.48-4.11.94-4.81.65-.96-.25 1.13.14 2.49.26.91 1.09 1.51 1.78 1.69.09.02.18-.06.17-.15-.06-.52-.56-1.95.74-5.02.91-2.16 3.57-4.66 4.68-4.93.21-.05.1.25.02.44-1.16 2.58-.99 4.25-.26 5.35.71 1.06 3.14 2.94 3.36 5.34.17 1.84-.16 2.99-1.16 4.13-.08.09 0 .24.12.2 3.93-1.36 7.43-5.65 7.57-10.12.15-4.86-2.59-7.65-3.35-7.88h.01Z"
    })
  }));
};